import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { blue, green, grey } from '@mui/material/colors';

export const SummaryTabStyledContainer = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Box
      sx={{
        gap: '1.5rem',
        display: 'flex',
        flexDirection: 'column',

        '& .summaryCards': {
          gap: '0.5rem',
          display: 'grid',
          gridTemplateRows: 'repeat(2, auto)',

          '& .summaryCardsLine': {
            gap: '1rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',

            '& .usersCard': {
              display: 'flex',
              borderRadius: '4px',
              padding: '0.5rem 1rem',
              backgroundColor: green[50],
              justifyContent: 'space-between',
              border: `1px solid ${green[500]}`,
            },

            '& .totalsCard': {
              gap: '0.5rem',
              display: 'grid',
              padding: '1rem',
              borderRadius: '4px',
              gridTemplateRows: 'auto auto',
              border: `1px solid ${grey[500]}`,

              '& .totalsCardIconWrapper': {
                display: 'flex',
                padding: '0.25rem',
                borderRadius: '4px',
                alignItems: 'center',
                height: 'fit-content',
                justifyContent: 'center',
                backgroundColor: blue[50],
              },

              '& .totalsCardInfo': {
                gap: '0.5rem',
                display: 'flex',

                '& .totalsCardInfoItem': {
                  width: '100%',
                  padding: '0.5rem',
                  borderRadius: '4px',
                  backgroundColor: grey[100],
                },
              },
            },

            '& .createdByProposalsTypeCard': {
              height: '100%',
              display: 'flex',
              padding: '0.5rem',
              borderRadius: '4px',
              alignItems: 'center',
              backgroundColor: grey[50],
              justifyContent: 'space-between',
              border: `1px solid ${grey[500]}`,
            },

            '& .proposalsSummaryCard-loading': {
              position: 'relative',
              overflow: 'hidden',

              '&::after': {
                content: '""',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                position: 'absolute',
                animation: 'shimmer 1.5s infinite',
                background: `linear-gradient(90deg, transparent, ${grey[50]}, transparent)`,
              },

              '@keyframes shimmer': {
                '0%': {
                  transform: 'translateX(-100%)',
                },
                '100%': {
                  transform: 'translateX(100%)',
                },
              },
            },
          },
        },
      }}
    >
      {children}
    </Box>
  );
};
